"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AlertEvent = _interopRequireDefault(require("./AlertEvent"));

var _CarrierStatusCarrierAssignment = _interopRequireDefault(require("./CarrierStatusCarrierAssignment"));

var _CurrentShipmentAddress = _interopRequireDefault(require("./CurrentShipmentAddress"));

var _ShipmentMetadata = _interopRequireDefault(require("./ShipmentMetadata"));

var _SlimCompany = _interopRequireDefault(require("./SlimCompany"));

var _SlimDriver = _interopRequireDefault(require("./SlimDriver"));

var _SlimShipmentLineItem = _interopRequireDefault(require("./SlimShipmentLineItem"));

var _Stop = _interopRequireDefault(require("./Stop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The AlertDashboardSlimShipment model module.
 * @module model/AlertDashboardSlimShipment
 * @version 2.7.64
 */
var AlertDashboardSlimShipment = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>AlertDashboardSlimShipment</code>.
   * @alias module:model/AlertDashboardSlimShipment
   */
  function AlertDashboardSlimShipment() {
    _classCallCheck(this, AlertDashboardSlimShipment);

    AlertDashboardSlimShipment.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(AlertDashboardSlimShipment, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>AlertDashboardSlimShipment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AlertDashboardSlimShipment} obj Optional instance to populate.
     * @return {module:model/AlertDashboardSlimShipment} The populated <code>AlertDashboardSlimShipment</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new AlertDashboardSlimShipment();

        if (data.hasOwnProperty('active_alert_events')) {
          obj['active_alert_events'] = _ApiClient["default"].convertToType(data['active_alert_events'], [_AlertEvent["default"]]);
        }

        if (data.hasOwnProperty('additional_bol_recipients')) {
          obj['additional_bol_recipients'] = _ApiClient["default"].convertToType(data['additional_bol_recipients'], ['String']);
        }

        if (data.hasOwnProperty('alert_types')) {
          obj['alert_types'] = _ApiClient["default"].convertToType(data['alert_types'], ['String']);
        }

        if (data.hasOwnProperty('bol_number')) {
          obj['bol_number'] = _ApiClient["default"].convertToType(data['bol_number'], 'String');
        }

        if (data.hasOwnProperty('current_address')) {
          obj['current_address'] = _CurrentShipmentAddress["default"].constructFromObject(data['current_address']);
        }

        if (data.hasOwnProperty('customer')) {
          obj['customer'] = _SlimCompany["default"].constructFromObject(data['customer']);
        }

        if (data.hasOwnProperty('documents_count')) {
          obj['documents_count'] = _ApiClient["default"].convertToType(data['documents_count'], 'Number');
        }

        if (data.hasOwnProperty('driver')) {
          obj['driver'] = _SlimDriver["default"].constructFromObject(data['driver']);
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('is_watchable')) {
          obj['is_watchable'] = _ApiClient["default"].convertToType(data['is_watchable'], 'Boolean');
        }

        if (data.hasOwnProperty('is_watched')) {
          obj['is_watched'] = _ApiClient["default"].convertToType(data['is_watched'], 'Boolean');
        }

        if (data.hasOwnProperty('line_items')) {
          obj['line_items'] = _ApiClient["default"].convertToType(data['line_items'], [_SlimShipmentLineItem["default"]]);
        }

        if (data.hasOwnProperty('messages_count')) {
          obj['messages_count'] = _ApiClient["default"].convertToType(data['messages_count'], 'Number');
        }

        if (data.hasOwnProperty('metadata')) {
          obj['metadata'] = _ShipmentMetadata["default"].constructFromObject(data['metadata']);
        }

        if (data.hasOwnProperty('next_planned_stop_id')) {
          obj['next_planned_stop_id'] = _ApiClient["default"].convertToType(data['next_planned_stop_id'], 'String');
        }

        if (data.hasOwnProperty('notes_count')) {
          obj['notes_count'] = _ApiClient["default"].convertToType(data['notes_count'], 'Number');
        }

        if (data.hasOwnProperty('reference_id')) {
          obj['reference_id'] = _ApiClient["default"].convertToType(data['reference_id'], 'String');
        }

        if (data.hasOwnProperty('relationship_to_vendor')) {
          obj['relationship_to_vendor'] = _CarrierStatusCarrierAssignment["default"].constructFromObject(data['relationship_to_vendor']);
        }

        if (data.hasOwnProperty('state')) {
          obj['state'] = _ApiClient["default"].convertToType(data['state'], 'String');
        }

        if (data.hasOwnProperty('stops')) {
          obj['stops'] = _ApiClient["default"].convertToType(data['stops'], [_Stop["default"]]);
        }

        if (data.hasOwnProperty('tracking_type')) {
          obj['tracking_type'] = _ApiClient["default"].convertToType(data['tracking_type'], 'String');
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }
      }

      return obj;
    }
  }]);

  return AlertDashboardSlimShipment;
}();
/**
 * @member {Array.<module:model/AlertEvent>} active_alert_events
 */


AlertDashboardSlimShipment.prototype['active_alert_events'] = undefined;
/**
 * Additional email address to send the BOL to upon booking
 * @member {Array.<String>} additional_bol_recipients
 */

AlertDashboardSlimShipment.prototype['additional_bol_recipients'] = undefined;
/**
 * @member {Array.<module:model/AlertDashboardSlimShipment.AlertTypesEnum>} alert_types
 */

AlertDashboardSlimShipment.prototype['alert_types'] = undefined;
/**
 * @member {String} bol_number
 */

AlertDashboardSlimShipment.prototype['bol_number'] = undefined;
/**
 * @member {module:model/CurrentShipmentAddress} current_address
 */

AlertDashboardSlimShipment.prototype['current_address'] = undefined;
/**
 * @member {module:model/SlimCompany} customer
 */

AlertDashboardSlimShipment.prototype['customer'] = undefined;
/**
 * @member {Number} documents_count
 */

AlertDashboardSlimShipment.prototype['documents_count'] = undefined;
/**
 * @member {module:model/SlimDriver} driver
 */

AlertDashboardSlimShipment.prototype['driver'] = undefined;
/**
 * @member {String} id
 */

AlertDashboardSlimShipment.prototype['id'] = undefined;
/**
 * @member {Boolean} is_watchable
 */

AlertDashboardSlimShipment.prototype['is_watchable'] = undefined;
/**
 * @member {Boolean} is_watched
 */

AlertDashboardSlimShipment.prototype['is_watched'] = undefined;
/**
 * @member {Array.<module:model/SlimShipmentLineItem>} line_items
 */

AlertDashboardSlimShipment.prototype['line_items'] = undefined;
/**
 * @member {Number} messages_count
 */

AlertDashboardSlimShipment.prototype['messages_count'] = undefined;
/**
 * @member {module:model/ShipmentMetadata} metadata
 */

AlertDashboardSlimShipment.prototype['metadata'] = undefined;
/**
 * @member {String} next_planned_stop_id
 */

AlertDashboardSlimShipment.prototype['next_planned_stop_id'] = undefined;
/**
 * @member {Number} notes_count
 */

AlertDashboardSlimShipment.prototype['notes_count'] = undefined;
/**
 * @member {String} reference_id
 */

AlertDashboardSlimShipment.prototype['reference_id'] = undefined;
/**
 * @member {module:model/CarrierStatusCarrierAssignment} relationship_to_vendor
 */

AlertDashboardSlimShipment.prototype['relationship_to_vendor'] = undefined;
/**
 * @member {module:model/AlertDashboardSlimShipment.StateEnum} state
 */

AlertDashboardSlimShipment.prototype['state'] = undefined;
/**
 * @member {Array.<module:model/Stop>} stops
 */

AlertDashboardSlimShipment.prototype['stops'] = undefined;
/**
 * @member {String} tracking_type
 */

AlertDashboardSlimShipment.prototype['tracking_type'] = undefined;
/**
 * @member {Date} updated_at
 */

AlertDashboardSlimShipment.prototype['updated_at'] = undefined;
/**
 * Allowed values for the <code>alertTypes</code> property.
 * @enum {String}
 * @readonly
 */

AlertDashboardSlimShipment['AlertTypesEnum'] = {
  /**
   * value: "LATE_PICKUP"
   * @const
   */
  "LATE_PICKUP": "LATE_PICKUP",

  /**
   * value: "LATE_DELIVERY"
   * @const
   */
  "LATE_DELIVERY": "LATE_DELIVERY",

  /**
   * value: "RUNNING_LATE"
   * @const
   */
  "RUNNING_LATE": "RUNNING_LATE",

  /**
   * value: "CARRIER_NOT_ASSIGNED"
   * @const
   */
  "CARRIER_NOT_ASSIGNED": "CARRIER_NOT_ASSIGNED",

  /**
   * value: "NOT_TRACKING"
   * @const
   */
  "NOT_TRACKING": "NOT_TRACKING",

  /**
   * value: "INACTIVE_CARRIER"
   * @const
   */
  "INACTIVE_CARRIER": "INACTIVE_CARRIER",

  /**
   * value: "TAGGED_SHIPMENT"
   * @const
   */
  "TAGGED_SHIPMENT": "TAGGED_SHIPMENT",

  /**
   * value: "WATCHED_SHIPMENT"
   * @const
   */
  "WATCHED_SHIPMENT": "WATCHED_SHIPMENT",

  /**
   * value: "RESOLVED_ALERTS"
   * @const
   */
  "RESOLVED_ALERTS": "RESOLVED_ALERTS",

  /**
   * value: "POWER_UNIT_NOT_ASSIGNED"
   * @const
   */
  "POWER_UNIT_NOT_ASSIGNED": "POWER_UNIT_NOT_ASSIGNED",

  /**
   * value: "DETENTION"
   * @const
   */
  "DETENTION": "DETENTION"
};
/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */

AlertDashboardSlimShipment['StateEnum'] = {
  /**
   * value: "appointment_pending"
   * @const
   */
  "appointment_pending": "appointment_pending",

  /**
   * value: "at_pickup"
   * @const
   */
  "at_pickup": "at_pickup",

  /**
   * value: "at_delivery"
   * @const
   */
  "at_delivery": "at_delivery",

  /**
   * value: "auction_running"
   * @const
   */
  "auction_running": "auction_running",

  /**
   * value: "cancelled"
   * @const
   */
  "cancelled": "cancelled",

  /**
   * value: "carrier_confirmed"
   * @const
   */
  "carrier_confirmed": "carrier_confirmed",

  /**
   * value: "delayed"
   * @const
   */
  "delayed": "delayed",

  /**
   * value: "delivered"
   * @const
   */
  "delivered": "delivered",

  /**
   * value: "dispatched"
   * @const
   */
  "dispatched": "dispatched",

  /**
   * value: "draft"
   * @const
   */
  "draft": "draft",

  /**
   * value: "in_transit"
   * @const
   */
  "in_transit": "in_transit",

  /**
   * value: "out_for_delivery"
   * @const
   */
  "out_for_delivery": "out_for_delivery",

  /**
   * value: "quote_accepted"
   * @const
   */
  "quote_accepted": "quote_accepted",

  /**
   * value: "quoting"
   * @const
   */
  "quoting": "quoting",

  /**
   * value: "reconciled"
   * @const
   */
  "reconciled": "reconciled",

  /**
   * value: "scheduled"
   * @const
   */
  "scheduled": "scheduled",

  /**
   * value: "tendered"
   * @const
   */
  "tendered": "tendered"
};
var _default = AlertDashboardSlimShipment;
exports["default"] = _default;